import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "We're a technology-led digital marketing team helping businesses grow online through search, social, paid media and content — all pulling in the same direction toward measurable results.",
    "Strategy comes first: we plan around your goals, then execute across channels and report on what actually matters — traffic, leads and conversions.",
];

const FEATURES = [
    { title: "Integrated strategy", text: "SEO, PPC, social and content coordinated as one plan, not silos." },
    { title: "More targeted traffic", text: "Reach the people most likely to become customers, not just clicks." },
    { title: "Higher conversion rates", text: "Optimise the whole journey, from first impression to enquiry." },
    { title: "Creative that performs", text: "Strategy, planning and creativity working together for real impact." },
];

const CHECKS = [
    "Get more targeted traffic",
    "Increase conversion rates",
    "Digital strategy & planning",
    "Creative campaigns",
    "Analytics & reporting",
];

export default function DigitalMarketing() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Digital Marketing" title="Digital Marketing Services" eyebrowAs="span">
                    A leading team for SEO, SMO, PPC and SMM — digital strategy, planning and creativity that drives measurable growth.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
